import { CssBaseline, useMediaQuery, useTheme } from "@mui/material";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Theme } from "./theme/Theme";
import Signup from "./pages/Signup/Signup";
import Settings from "./pages/Settings/Settings";
import Login from "./pages/Login/Login";
import { useState, useRef } from "react";
import SearchResultsWithChat from "./features/search/pages/SearchResultsPage";
import SearchEntryScreen from "./features/search/pages/SearchEntryScreen";
import Company from "./pages/Company";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import DesktopShell from "./components/layout/DesktopShell";
import MobileShell from "./components/layout/MobileShell";

function App() {
  const [keyword, setKeyword] = useState<string>("");

  const sidebarOpenRef = useRef(true);
  const [, forceRender] = useState(false);

  const toggleSidebar = () => {
    sidebarOpenRef.current = !sidebarOpenRef.current;
    forceRender((v) => !v);
  };

  const location = useLocation();
  const hideSidebar = ["/login", "/signup"].includes(location.pathname);

  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));

  const content = (
    <Routes>
      <Route
        path="/search-entry"
        element={<SearchEntryScreen keyword={keyword} setKeyword={setKeyword} />}
      />
      <Route
        path="/search-results"
        element={<SearchResultsWithChat keyword={keyword} setKeyword={setKeyword} />}
      />
      <Route path="/settings" element={<Settings />} />
      <Route path="/" element={<Navigate to="/search-entry" />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/company" element={<Company />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="*" element={<Navigate to="/search-entry" replace />} />
    </Routes>
  );

  return (
    <Theme>
      <CssBaseline />
      {isMobile ? (
        <MobileShell hideSidebar={hideSidebar}>{content}</MobileShell>
      ) : (
        <DesktopShell
          hideSidebar={hideSidebar}
          sidebarOpen={sidebarOpenRef.current}
          onToggleSidebar={toggleSidebar}
        >
          {content}
        </DesktopShell>
      )}
    </Theme>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}